import { Component, OnInit, ViewChild } from '@angular/core';
import { Fazenda } from 'src/app/classes/Fazenda';
import { FazendaService } from 'src/app/services/fazenda.service';
import { ActivatedRoute, Router } from '@angular/router';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';
import { StorageService } from 'src/app/services/storage.service';
import { LoginService } from 'src/app/services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { NavbarService } from 'src/app/services/navbar.service';
import { Location } from '@angular/common';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import moment from 'moment';

@Component({
  selector: 'app-fazenda',
  templateUrl: './fazenda.component.html',
  styleUrls: ['./fazenda.component.scss']
})
export class FazendaComponent implements OnInit {
  @ViewChild("gridFazendas", { static: false })
  gridFazendas: SyncGridComponent;

  fazendas: Fazenda[];
  auxFazendas: Fazenda[];
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  textoBusca: string = "";
  perfilLogado: number = 0;

  fazendaColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  inativando: boolean = false
  duplicando: boolean = false
  gridHeight: string = '79vh';

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  // tradução
  ERRO: string = 'Erro!';
  FEITO: string = 'Feito!';
  SIM: string = 'Sim';
  CANCELAR: string = 'Cancelar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  FAZENDA_DELETADA: string = 'Fazenda deletada!';

  constructor(
    private utils: UtilsService,
    private fazendaService: FazendaService,
    private navbarService: NavbarService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private loginService: LoginService,
    private translate: TranslateService,
    private location: Location) {
    if (this.router.url.search("inserir") > 0) {
      if (!this.utils.verificarPermissaoUsuario('IncluirFazenda')) {
        this.location.back();
      }
    }

    this.route.params.subscribe(res => {
      this.id = res.id;
      if (res.id && res.id > 0 && this.router.url.search("inserir") < 0) {
        if (!this.utils.verificarPermissaoUsuario('EditarFazenda')) {
          this.location.back();
        }
      }
    });
  }

  ngOnInit() {
    this.perfilLogado = this.storageService.getUsuario().Perfil;
    this.inserindo = this.router.url.search("inserir") > 0;

    if (this.id > 0) {
      // Carregar fazenda para edição
    } else {
      this.listarFazendas();
      this.configurarGrid();
    }
  }

  listarFazendas() {
    this.configurarTraducao();
    this.carregando = true;
    this.fazendaService.getTodasFazendas().subscribe(
      res => {
        this.fazendas = res.map(u => Object.assign(new Fazenda(), u));
        this.auxFazendas = res.map(u => Object.assign(new Fazenda(), u));;
        this.carregando = false;

        if (this.textoBusca != '')
          this.filtrarFazendas();

      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      });
  }
  novo(): void {
    this.router.navigate(['/cadastros/fazenda/inserir']);
  }

  finalizarSaveFazenda(): void {
    // Notificar o navbar para atualizar a lista de fazendas
    this.navbarService.notificarAtualizacaoFazendas();

    this.listarFazendas();
    if (this.inserindo) {
      this.router.navigate(['/cadastros/fazenda']);
    }
  }

  cancelarFazenda(): void {
    this.router.navigate(['/cadastros/fazenda']);
  }


  filtrarFazendas() {
    this.fazendas = this.auxFazendas.filter(x =>
      x.Nome.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca)
    );
  }


  confirmRemover() {
    var fazendas = this.gridFazendas.getSelectedRecords();
    if (fazendas.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: 'Se deletar, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim',
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerFazendas(fazendas)
    });
  }

  removerFazendas(fazendas: Fazenda[]) {
    this.removendo = true;
    this.fazendaService.deleteFazendas(fazendas.map(f => f.Id)).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais fazendas falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const fazenda = fazendas.find(v => v.Id.toString() === id);
            const nomeFazenda = fazenda ? fazenda.Nome : `ID ${id}`;
            erros.push(`<b>${nomeFazenda}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir fazendas',
            html: `As seguintes fazendas não puderam ser excluídas:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os fazendas foram excluídos
          this.utils.handleSuccess("Fazendas excluídos com sucesso");
        }

        // Notificar o navbar para atualizar a lista de fazendas
        this.navbarService.notificarAtualizacaoFazendas();

        this.listarFazendas();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });
  }

  confirmaDuplicar(): void {
    var fazendas = this.gridFazendas.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "As fazendas selecionadas serão duplicadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar fazendas",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(fazendas);
      }
    });
  }

  duplicar(fazendas: Fazenda[]): void {
    this.duplicando = true
    this.fazendaService.duplicar(fazendas.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Fazendas duplicadas com sucesso")

        // Notificar o navbar para atualizar a lista de fazendas
        this.navbarService.notificarAtualizacaoFazendas();

        this.listarFazendas();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return
    var fazendas = this.gridFazendas.getSelectedRecords();
    if (fazendas.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "As fazendas selecionadas serão inativadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar fazendas",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(fazendas);
      }
    });

  }

  inativar(fazendas: Fazenda[]): void {
    this.inativando = true
    const fazendaSelecionada = this.storageService.getFazenda();
    const fazendaSelecionadaId = fazendaSelecionada ? fazendaSelecionada.Id : null;

    this.fazendaService.inativar(fazendas.map(p => p.Id))
      .subscribe((res) => {
        // Verificar se a fazenda selecionada foi inativada (antes de processar erros)
        const fazendaSelecionadaInativada = fazendaSelecionadaId &&
          fazendas.some(f => f.Id === fazendaSelecionadaId) &&
          (!res || typeof res !== 'object' || !res[fazendaSelecionadaId.toString()]);

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais fazendas falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const fazenda = fazendas.find(v => v.Id.toString() === id);
            const nomeFazenda = fazenda ? fazenda.Nome : `ID ${id}`;
            erros.push(`<b>${nomeFazenda}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao inativar fazendas',
            html: `As seguintes fazendas não puderam ser inativadas:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todas as fazendas foram inativadas
          this.utils.handleSuccess("Fazendas inativadas com sucesso");
        }

        // Se a fazenda selecionada foi inativada, deslogar o usuário
        if (fazendaSelecionadaInativada) {
          this.loginService.logout();
          return;
        }

        // Notificar o navbar para atualizar a lista de fazendas
        this.navbarService.notificarAtualizacaoFazendas();

        this.listarFazendas();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement;
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement;
      const title = document.querySelector('app-fazenda h5.m-b-10.titulo') as HTMLElement;
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement;

      if (!navbar || !toolbar || !title) return;

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;
      const pagerHeight = pager ? pager.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pagerHeight - 70;
      this.gridHeight = `${altura}px`;
    }, 100);
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40;

    this.fazendaColumns = [
      {
        type: "checkbox",
        width: 40,
        showInColumnChooser: false
      },
      {
        field: "Nome",
        headerText: "Nome",
        allowSorting: true,
        type: "string",
      },
      {
        field: "Latitude",
        headerText: "Latitude",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Longitude",
        headerText: "Longitude",
        type: "string",
        allowSorting: true,
      },
      {
        field: "AreaIrrigada",
        headerText: "Área Irrigada (Ha)",
        type: "number",
        allowSorting: true,
      },
      {
        field: "AreaSequeiro",
        headerText: "Área Sequeiro (Ha)",
        type: "number",
        allowSorting: true,
      },
      {
        field: "AreaTotal",
        headerText: "Área Total (Ha)",
        type: "number",
        allowSorting: true,
      },
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      } as ColumnModel
    ]
    this.ajustarTamanhoGrid();
  }
  doubleClick(event): void {
    this.editar(event)
  }
  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  editar(fazenda: Fazenda): void {
    let fazend;
    if (!fazenda) {
      var fazendas = this.gridFazendas.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      fazend = { ...fazendas[0] };
    }
    else
      fazend = { ...fazenda }
    this.router.navigate(['/cadastros/fazenda/' + fazend.Id]);
  }

  ValidarSelectApenasUm(): boolean {
    var fazendas = this.gridFazendas.getSelectedRecords();
    if (fazendas.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (fazendas.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var fazendas = this.gridFazendas.getSelectedRecords();
    if (fazendas.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.FEITO = this.translate.instant('FEITO');
    this.SIM = this.translate.instant('SIM');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.FAZENDA_DELETADA = this.translate.instant('FAZENDA_DELETADA');
  }

}
